/* * @Author: Wei Guojun * @Date: 2021-04-09 10:11:23 * @Last Modified by: Wei
Guojun * @Last Modified time: 2021-12-29 14:33:03 */
<template>
  <div class="home">
    <div class="gotoback">
      <el-button type="primary" @click="gotoback" size="mini">返回</el-button>
    </div>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
      size="small"
    >
      <div class="model sender">
        <el-row class="_header"></el-row>
        <div class="from">
          <div class="header_title">
            <img src="@/assets/images/icon_ji.png" alt />
            <span>寄件人信息</span>
          </div>
          <div class="addRecever">
            <img src="@/assets/images/add.png" alt />
            <a @click="selectAddress('send')" href="javascript:void(0)">添加收件人</a>
          </div>
          <el-row>
            <el-col class="title" :span="2">
              <div>智能解析</div>
            </el-col>
            <el-col :span="21">
              <div>
                <el-input
                  placeholder="例如： 张三 18888888888 上海 上海市 黄浦区 延安东路888号88室 "
                  v-model="ruleForm.send.analysis"
                  clearable
                  size="small"
                  @Input="doAnalysis(ruleForm.send.analysis, 'send')"
                />
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <div>
                <el-row>
                  <el-col class="title" :span="4">
                    <div>姓名</div>
                  </el-col>
                  <el-col class="input" :span="20">
                    <el-form-item style="margin-left: 0" prop="send.name">
                      <el-autocomplete
                        placeholder="请输入姓名"
                        suffix-icon="el-icon-user"
                        v-model="ruleForm.send.name"
                        clearable
                        :fetch-suggestions="
                          (queryString, cb) => {
                            querySearch(queryString, cb, 1)
                          }
                        "
                        :trigger-on-focus="false"
                        @select="
                          (item) => {
                            handleSelect(item, 'send')
                          }
                        "
                      ></el-autocomplete>
                      <span class="span">*</span>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
            </el-col>
            <el-col :span="12">
              <div>
                <el-row>
                  <el-col class="title" :span="4">
                    <div>联系方式</div>
                  </el-col>
                  <el-col class="input" :span="20">
                    <div>
                      <el-form-item prop="send.phone">
                        <el-input
                          type="text"
                          placeholder="请输入联系手机或电话"
                          v-model.trim="ruleForm.send.phone"
                          suffix-icon="el-icon-phone-outline"
                          clearable
                        ></el-input>
                        <span class="span">*</span>
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </el-col>
          </el-row>
          <el-row style="margin-bottom: 15px">
            <el-col :span="12">
              <div>
                <el-row>
                  <el-col class="title" :span="4">
                    <div>省/市/区</div>
                  </el-col>
                  <el-col class="input" :span="20">
                    <div>
                      <el-form-item prop="send.pca">
                        <el-cascader
                          @blur="checkDizhi"
                          @change="changeAddress('send')"
                          ref="send"
                          :options="sender_address"
                          v-model="ruleForm.send.pca"
                          placeholder="请选择省/市/区"
                          filterable
                        ></el-cascader>
                        <span class="span">*</span>
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </el-col>
            <el-col :span="12">
              <div>
                <el-row>
                  <el-col class="title" :span="4">
                    <div>详细地址</div>
                  </el-col>
                  <el-col class="input" :span="20">
                    <div>
                      <el-form-item prop="send.address">
                        <el-input
                          @blur="checkDizhi"
                          type="text"
                          placeholder="请输入详细地址"
                          suffix-icon="el-icon-map-location"
                          v-model.trim="ruleForm.send.address"
                          clearable
                        ></el-input>
                        <span class="span">*</span>
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </el-col>
          </el-row>
          <div class="checkbox">
            <el-checkbox
              v-model="ruleForm.send.save_info"
              label="保存到我的寄件人"
              name="type"
            ></el-checkbox>
          </div>
        </div>
      </div>
      <div class="model addressee">
        <el-row class="_header"></el-row>
        <div class="from">
          <div class="header_title">
            <img src="@/assets/images/icon_show.png" alt />
            <span>收件人信息</span>
          </div>
          <div class="addRecever">
            <img src="@/assets/images/add.png" alt />
            <a @click="selectAddress('collect')" href="javascript:void(0)">添加收件人</a>
          </div>
          <div class="collectBox">
            <el-row>
              <el-col class="title" :span="2">
                <div>智能解析</div>
              </el-col>
              <el-col :span="21">
                <div class="flexBetween">
                  <el-input
                    placeholder="例如： 张三 18888888888 上海 上海市 黄浦区 延安东路888号88室 "
                    v-model="ruleForm.collect.analysis"
                    clearable
                    size="small"
                    @Input="doAnalysis(ruleForm.collect.analysis, 'collect')"
                  >
                  </el-input>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <div>
                  <el-row>
                    <el-col class="title" :span="4">
                      <div>收件人姓名</div>
                    </el-col>
                    <el-col class="input" :span="20">
                      <div>
                        <el-form-item prop="collect.name">
                          <el-autocomplete
                            placeholder="请输入姓名"
                            suffix-icon="el-icon-user"
                            v-model="ruleForm.collect.name"
                            clearable
                            :fetch-suggestions="
                              (queryString, cb) => {
                                querySearch(queryString, cb, 0)
                              }
                            "
                            :trigger-on-focus="false"
                            @select="
                              (item) => {
                                handleSelect(item, 'collect')
                              }
                            "
                          ></el-autocomplete>
                          <span class="span">*</span>
                        </el-form-item>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </el-col>
              <el-col :span="12">
                <div>
                  <el-row>
                    <el-col class="title" :span="4">
                      <div>联系方式</div>
                    </el-col>
                    <el-col class="input" :span="20">
                      <div>
                        <el-form-item prop="collect.phone">
                          <el-input
                            type="text"
                            placeholder="请输入联系手机或电话"
                            v-model.trim="ruleForm.collect.phone"
                            suffix-icon="el-icon-phone-outline"
                            clearable
                          ></el-input>
                          <span class="span">*</span>
                        </el-form-item>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </el-col>
            </el-row>
            <el-row style="margin-bottom: 15px">
              <el-col :span="12">
                <div>
                  <el-row>
                    <el-col class="title" :span="4">
                      <div>省/市/区</div>
                    </el-col>
                    <el-col class="input" :span="20">
                      <div>
                        <el-form-item prop="collect.pca">
                          <el-cascader
                            @blur="checkDizhi"
                            @change="changeAddress('collect')"
                            ref="collect"
                            :options="sender_address"
                            v-model="ruleForm.collect.pca"
                            placeholder="请选择省/市/区"
                            filterable
                          ></el-cascader>
                          <span class="span">*</span>
                        </el-form-item>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </el-col>
              <el-col :span="12">
                <div>
                  <el-row>
                    <el-col class="title" :span="4">
                      <div>详细地址</div>
                    </el-col>
                    <el-col class="input" :span="20">
                      <div>
                        <el-form-item prop="collect.address">
                          <el-input
                            @blur="checkDizhi"
                            type="text"
                            placeholder="请输入详细地址"
                            suffix-icon="el-icon-map-location"
                            v-model.trim="ruleForm.collect.address"
                            clearable
                          ></el-input>
                          <span class="span">*</span>
                        </el-form-item>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </el-col>
            </el-row>
            <el-row v-show="addressClose" style="margin-bottom: 0px">
              <el-col :span="12">
                <div>
                  <el-row>
                    <el-col class="title" :span="4"> </el-col>
                    <el-col class="input" :span="20" style="color: red">
                      * 此地址暂时存在“网点停发”情况
                    </el-col>
                  </el-row>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
      <div class="model other">
        <div class="from">
          <el-row>
            <el-col class="title" :span="2">
              <div>物品信息</div>
            </el-col>
            <el-col class="input" :span="6">
              <div>
                <el-form-item>
                  <el-input
                    class="goods-input"
                    size="small"
                    v-model="goodsAweight"
                    @focus="showGoodsPicker = true"
                  />
                  <span class="span">*</span>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="8" v-if="!isfrom">
              <div>
                <el-row>
                  <el-col class="title" :span="4">
                    <div>寄付运费</div>
                  </el-col>
                  <el-col class="input" :span="18">
                    <div>
                      <el-form-item>
                        <el-input
                          type="text"
                          size="small"
                          placeholder="请输入"
                          v-model.trim="daofu_amount"
                          @input="moneyInput"
                          @blur="moenyBlur"
                          clearable
                        >
                          <template slot="append">元</template></el-input
                        >
                      </el-form-item>
                    </div>
                    <font style="font-size:12px">非必填，由业务员输入，运费将打印在面单上</font>
                  </el-col>
                </el-row>
              </div>
            </el-col>
            <el-col :span="8" v-else>
              <div>
                <el-row>
                  <el-col class="title" :span="4">
                    <div>快递类型</div>
                  </el-col>
                  <el-col class="input" :span="18">
                    <div>
                      <el-form-item>
                        <el-select
                          size="small"
                          v-model="express_type"
                          placeholder="快递类型"
                        >
                          <el-option
                            v-for="item in expressArr"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </el-col>
          </el-row>
          <el-row style="padding-top: 20px;">
            <el-col class="title" :span="2">
              <div>包裹备注</div>
            </el-col>
            <el-col class="input" :span="22">
              <div>
                <el-form-item>
                  <el-input
                    type="text"
                    placeholder="选填项,注意由快递员打印的订单备注只可打出20字"
                    maxlength="60"
                    height="100%"
                    show-word-limit
                    v-model.trim="textarea"
                  ></el-input>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-form>
    <div class="zzfu-n">
      <value-add @servicesType="servicesType" ref="valueAdd" :initmore="false" v-if="!isfrom"></value-add>
    </div>
    <footer>
      <div class="footer">
        <el-button type="warning" class="footBtn" @click.prevent="waitPrint"
          >保 存</el-button
        >
      </div>
    </footer>
    <div v-if="dialog" class="zMark">
      <el-dialog
        center
        top="50px"
        width="1000px"
        :title="dialog_title"
        :visible.sync="dialog"
        @close="closeDialog"
      >
        <div
          :style="{ height: address_type == 'editCollect' ? '320px' : '580px' }"
        >
          <v-address
            ref="collectList"
            v-if="address_type == 'collect'"
            :forCustmer="true"
          ></v-address>
          <v-send-address
            ref="sendList"
            v-if="address_type == 'send'"
          ></v-send-address>
        </div>
      </el-dialog>
    </div>
    <goods-picker
      ref="goodsPicker"
      :visible="showGoodsPicker"
      :initReceipt="false"
      @close="showGoodsPicker = false"
      @picked="handlePickGoods"
    />
  </div>
</template>
<script>
import vAddress from '@/components/address.vue'
import vSendAddress from '@/components/send_address.vue'
import goodsPicker from '@/components/goodsPicker.vue'
import home from '@/api/home'
import util from '@/util/util'
import { mapGetters } from 'vuex'
import Rule from '@/util/rule.js'
import valueAdd from '@/components/value_addservices.vue'
export default {
  name: 'editBill',
  data() {
    return {
      daofu_amount: '',
      province: '',
      city: '',
      block: '',
      ysdswitch: false,
      ysSwitch: false,
      select_type: 'send',
      save_btn: false,
      dialog_title: '选择寄件人',
      dialog: false,
      address_type: '', //选择地址类型
      first_click: true,
      isEdit: false,
      fieldCollect: [
        //收件验证字段
        'collect.name',
        'collect.phone',
        'collect.address',
        'collect.pca',
      ],
      fieldSend: [
        //寄件人验证字段
        'send.name',
        'send.phone',
        'send.address',
        'send.pca',
      ],
      addserve: [
        { label: '寄付', value: 'pt' },
        { label: '到付', value: 'topay' },
      ],
      sender_address: [], // 寄件人地区选项配置
      typeContent: '', //物品类型
      goods_weight:1,
      maiServe: 'pt', //增值服务
      topayOnoff: false,
      textarea: '', //备注说明
      parcel_id: '', //修改包裹id
      Added_Collect: [], //已添加过的收件人
      isImport: false, // 编辑临时包裹
      print_btn: false,
      ruleForm: {
        send: {
          save_info: false, // 是否保存信息
          analysis: '', // 解析数据
          isAnalysis: false,
          name: '', // 姓名
          phone: '', // 手机号
          province: '', // 省
          province_code: '', //省编码
          city: '', // 市
          city_code: '', //市编码
          city_list: [], // 市列表数据
          area: '', //区
          area_code: '', //区编码
          area_list: [], //区列表
          address: '', // 详细地址
          pca: '', // 省市区
        },
        collect: {
          save_info: true, // 是否保存信息
          analysis: '', // 解析数据
          isAnalysis: false,
          name: '', // 姓名
          phone: '', // 手机号
          province: '', // 省
          province_code: '', //省编码
          city: '', // 市
          city_code: '', //市编码
          city_list: [], // 市列表
          area: '',
          area_code: '', //区编码
          area_list: [], //区列表
          address: '', // 详细地址
          pca: '', // 省市区
          type: '', //类型
        },
      },
      rules: Rule,
      Isprint: false,
      editcollectIndex: -1,
      package_count: 1,
      switchShow: false,
      anslsList: [],
      errorNum: 0,
      rightNum: 0,
      rightArr: [],
      addConfig: false,
      yddserve: false,
      searchTimeout: '',
      dialogFormVisible: false,
      addressClose: false,
      showGoodsPicker: false,
      isfrom:'',
      express_type:'',//批量下单编辑的快递类型
      expressArr:[ //批量下单
        { label: "普通快递", value: "PK" },
        { label: "智橙网", value: "TK" },
      ],
    }
  },
  computed: {
    ...mapGetters(['getFrom']),
    goodsAweight(){
      if(this.typeContent && this.goods_weight){
        return this.typeContent+','+this.goods_weight+'KG'
      }else{
        return this.typeContent
      }
    }
  },
  components: {
    vAddress,
    vSendAddress,
    goodsPicker,
    valueAdd
  },
  created: function () {
    this.getCityData()
  },
  mounted() {
    const editData = JSON.parse(this.$store.state.editbill)
    console.log(editData)
    this.isfrom = editData.isfrom;
    this.ruleForm.send.name = editData.sender_name
    this.ruleForm.send.phone = editData.sender_phone
    this.ruleForm.send.province = editData.sender_province
    this.ruleForm.send.province_code = editData.sender_province_code
    this.ruleForm.send.city = editData.sender_city
    this.ruleForm.send.city_code = editData.sender_city_code
    this.ruleForm.send.area = editData.sender_district
    this.ruleForm.send.area_code = editData.sender_district_code
    this.ruleForm.send.address = editData.sender_address
    this.ruleForm.send.pca = [
      editData.sender_province_code,
      editData.sender_city_code,
      editData.sender_district_code,
    ]

    this.ruleForm.collect.name = editData.receiver_name
    this.ruleForm.collect.phone = editData.receiver_phone
    this.ruleForm.collect.province = editData.receiver_province
    this.ruleForm.collect.province_code = editData.receiver_province_code
    this.ruleForm.collect.city = editData.receiver_city
    this.ruleForm.collect.city_code = editData.receiver_city_code
    this.ruleForm.collect.area = editData.receiver_district
    this.ruleForm.collect.area_code = editData.receiver_district_code
    this.ruleForm.collect.address = editData.receiver_address
    this.ruleForm.collect.pca = [
      editData.receiver_province_code,
      editData.receiver_city_code,
      editData.receiver_district_code,
    ]
    this.typeContent = editData.item_type
    this.goods_weight = editData.goods_weight
    this.$nextTick(() => {
      this.$refs.goodsPicker?.handlePublicSetCurrent?.(editData.item_type)
      if(!this.isfrom){
        this.$refs.valueAdd.oncenews(editData.pri,editData.express_type,editData.morder_marking_infos,true)
      }else{
        this.express_type = editData.express_type
      }
    })
    this.daofu_amount = editData.daofu_amount
    this.textarea = editData.item_note
    this.parcel_id = editData.order_id || editData.id
    // this.ysdswitch = editData.express_type == 'TK' ? true : false
    // const addsflag = util.getJsonValues(
    //   this.$store.state.commondict,
    //   'exvaluelist'
    // )
    // if (addsflag) {
    //   this.addConfig = true
    // }
    // //是否开启智橙网服务
    // const ydd_serve = util.getJsonValues(
    //   this.$store.state.commondict,
    //   'yousuda'
    // )
    // if (ydd_serve) {
    //   this.yddserve = true
    // }
    // this.ysSwitch = editData.pri == 'PRI' ? true : false
  },
  methods: {
    //失焦判断
    checkDizhi() {
      const {
        address,
        province_code,
        city_code,
        area_code,
        province,
        city,
        area,
      } = this.ruleForm.collect
      if (province_code && city_code && area_code && address) {
        const checkQuery = [
          {
            index: 0,
            receiver_province: province,
            receiver_city: city,
            receiver_district: area,
            receiver_address: address,
            sender_province: this.ruleForm.send.province,
            sender_city: this.ruleForm.send.city,
            sender_district: this.ruleForm.send.district,
            sender_address: this.ruleForm.send.address,
          },
        ]
        home.checkaddress(this, checkQuery).then((res) => {
          if (res.success) {
            res.data[0].status_desc != '正常'
              ? (this.addressClose = true)
              : (this.addressClose = false)
          }
        })
      } else {
        this.addressClose = false
      }
    },
    moneyInput(value) {
      const newVal = value.replace(/[^\d.]/g, '')
      if (newVal > 0 && newVal < 10000) {
        this.daofu_amount = newVal
      }
      if (newVal <= 0) {
        this.daofu_amount = ''
      }
      if (newVal >= 10000) {
        this.daofu_amount = 9999 + '.00'
      }
    },
    moenyBlur() {
      if (this.daofu_amount > 0) {
        this.daofu_amount = (this.daofu_amount - 0).toFixed(2)
      } else {
        this.daofu_amount = ''
      }
    },
    querySearch(queryString, cb, addressType) {
      home.lxAddress(this, queryString, addressType).then((res) => {
        var restaurants = []
        if (res.success) {
          restaurants = res.data.map((el) => {
            return {
              value:
                el.name +
                ' ' +
                el.phone +
                ' ' +
                el.province_name +
                ' ' +
                el.city_name +
                ' ' +
                el.district_name +
                ' ' +
                el.address,
              id: el.id,
              name: el.name,
            }
          })
        }
        var results = queryString
          ? restaurants.filter(this.createFilter(queryString))
          : restaurants
        // 调用 callback 返回建议列表的数据
        clearTimeout(this.timeout)
        this.searchTimeout = setTimeout(() => {
          cb(results)
        }, 3000 * Math.random())
      })
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        )
      }
    },
    handleSelect(item, type) {
      home.getAddressById(this, item.id).then((res) => {
        if (res.success) {
          const result = res.data
          this.ruleForm[type] = {
            name: result.name,
            phone: result.phone,
            province: result.province_name,
            province_code: result.province_code,
            city: result.city_name,
            city_code: result.city_code,
            area: result.district_name,
            area_code: result.district_code,
            address: result.address,
            pca: [result.province_code, result.city_code, result.district_code], // 省市区
          }
        }
      })
    },
    //选择到付提示
    serveChoose(val) {
      if (val == 'topay' && !this.topayOnoff) {
        // this.$alert('您暂无到付权限,请联系协议快递员,开启到付授权', '提示', {
        //   confirmButtonText: '确定',
        //   callback: action => {
        //     this.maiServe = 'pt';
        //   }
        // });
      }
      if (val == 'pt') {
        this.daofu_amount = ''
      }
    },
    //查询是否有到付权限
    getdfAuth() {
      home.addAuth(this).then((res) => {
        if (res.success && res.data.topay) {
          this.topayOnoff = true
        }
      })
    },
    typeChoose(val) {
      this.typeContent = val
    },
    getQueryVariable(variable) {
      var query = window.location.search.substring(1)
      var vars = query.split('&')
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=')
        if (pair[0] == variable) {
          return pair[1]
        }
      }
      return false
    },
    /** 稍后打印 */
    waitPrint() {
      this.changeTrigger('change')
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.save_btn = true
          this.createParcel()
        } else {
          this.$message.error('订单信息填写有误，请查看重新填写')
          return false
        }
      })
    },
    getCityData() {
      this.sender_address = this.ysbAddressFile.getcity()
    },

    /** 遍历地址 */
    forAddress(type) {
      let data = this.ruleForm[type]
      let res = []
      cityData.cityData.forEach((item) => {
        if (item.label == data.province) {
          res = [...res, item.value]
          item.children.forEach((ite) => {
            if (ite.label == data.city) {
              res = [...res, ite.value]
              ite.children.forEach((it) => {
                if (it.label == data.area) {
                  res = [...res, it.value]
                }
              })
            }
          })
        }
      })
      this.ruleForm[type].pca = res
    },
    /**关闭对应的Dialog */
    closeDialog() {
      this.dialog = false
    },

    /** 地址解析 */
    doAnalysis(analysis, type) {
      console.log(analysis, type)
      let self = this
      home.doAnalysis(self, analysis).then((res) => {
        if (res.success) {
          if (res.data.length == 1) {
            let data = res.data[0]
            self.ruleForm[type].pca = [
              data.province_code,
              data.city_code,
              data.district_code,
            ]
            self.ruleForm[type].name = data.name || ''
            self.ruleForm[type].phone = data.phone || ''
            self.ruleForm[type].province = data.province_name || ''
            self.ruleForm[type].city = data.city_name || ''
            self.ruleForm[type].area = data.district_name || ''
            self.ruleForm[type].province_code = data.province_code || ''
            self.ruleForm[type].city_code = data.city_code || ''
            self.ruleForm[type].area_code = data.district_code || ''
            self.ruleForm[type].address = data.address || ''
            self.checkDizhi()
          }
          if (res.data.length > 1) {
            this.anslsList = res.data
            this.fitInit()
          }
        }
      })
    },

    /**创建待打印包裹 */
    createParcel() {
      if (this.typeContent === '') {
        this.$message.error('请选择物品类型')
        return
      }
      if(!this.isfrom && !this.$refs.valueAdd.value_checkRrror() ){
         return  
      }
      let words = [
        { index: 0, origin_words: util.trimAll(this.textarea) },
        { index: 1, origin_words: util.trimAll(this.ruleForm.send.address) },
        { index: 2, origin_words: util.trimAll(this.ruleForm.collect.address) },
      ]
      home.sensitivewords(this, words).then((res) => {
        if (res.success) {
          const resultArr = res.data
          let filwordsArr = resultArr.filter(
            (el) => el.origin_words != el.sensitive_words
          )
          if (filwordsArr.length) {
            this.textarea = resultArr[0].sensitive_words
            this.ruleForm.send.address = resultArr[1].sensitive_words
            this.ruleForm.collect.address = resultArr[2].sensitive_words
            this.$confirm(
              '您输入的信息中含有敏感词请修改后重新操作点击忽略订单中将以“□”代替',
              '提示',
              {
                confirmButtonText: '忽略',
                cancelButtonText: '去修改',
                type: 'warning',
              }
            )
              .then(() => {
                this.tingfa_jg()
              })
              .catch(() => {})
          } else {
            this.tingfa_jg()
          }
        }
      })
    },
    tingfa_jg() {
      if (this.addressClose) {
        let tingfa = {
          content: '此订单暂时存在“网点停发”情况，是否继续保存订单到待打印中',
          ok: '继续保存',
          cacel: '再考虑下',
        }
        this.$confirm(tingfa.content, '提示', {
          confirmButtonText: tingfa.ok,
          cancelButtonText: tingfa.cacel,
          type: 'warning',
        })
          .then(() => {
            this.createActions()
          })
          .catch(() => {})
      } else {
        this.createActions()
      }
    },
    //下单交互
    createActions() {
      if (this.first_click) {
        this.first_click = false
        const sender = this.ruleForm.send
        const receiver = this.ruleForm.collect
        let query = null;
        if(this.isfrom){
          query = {
            account_id: util.getCookie("account_id"),
            id: this.parcel_id,
            id_result: true,
            item_note: this.textarea,
            item_note_result: true,
            item_type: this.typeContent,
            express_type:this.express_type,
            item_type_result: true,
            goods_weight:this.goods_weight,
            goods_weight_result: true,
            receiver_address: receiver.address,
            receiver_address_result: true,
            receiver_city: receiver.city,
            receiver_city_code: receiver.city_code,
            receiver_district: receiver.area,
            receiver_district_code: receiver.area_code,
            receiver_name: receiver.name,
            receiver_name_result: true,
            receiver_phone: receiver.phone,
            receiver_phone_result: true,
            receiver_province: receiver.province,
            receiver_province_code: receiver.province_code,
            sender_address: sender.address,
            sender_address_result: true,
            sender_city: sender.city,
            sender_city_code: sender.city_code,
            sender_district: sender.area,
            sender_district_code: sender.area_code,
            sender_name: sender.name,
            sender_name_result: true,
            sender_phone: sender.phone,
            sender_phone_result: true,
            sender_province: sender.province,
            sender_province_code: sender.province_code,
          };
        }else{
          let val_addObj = this.$refs.valueAdd.besure();
          query = {
          order_id: this.parcel_id,
          account_id: util.getCookie('account_id'),
          item_note: this.textarea,
          value_add_type: this.maiServe,
          item_type: this.typeContent,
          goods_weight:this.goods_weight,
          daofu_amount: this.daofu_amount,
          express_type : val_addObj.zc_switch ? "TK" : "PK", //智橙网服务
          pri:val_addObj.ys_switch ? "PRI" : '', // 隐私面单
          marking_infos:val_addObj.marking_infos, //保价，代收货款，签收统计等增值服务
          order_vo: {
            receiver_address: receiver.address,
            receiver_city: receiver.city,
            receiver_city_code: receiver.city_code,
            receiver_district: receiver.area,
            receiver_district_code: receiver.area_code,
            receiver_name: receiver.name,
            receiver_phone: receiver.phone,
            receiver_province: receiver.province,
            receiver_province_code: receiver.province_code,
            sender_address: sender.address,
            sender_city: sender.city,
            sender_city_code: sender.city_code,
            sender_district: sender.area,
            sender_district_code: sender.area_code,
            sender_name: sender.name,
            sender_phone: sender.phone,
            sender_province: sender.province,
            sender_province_code: sender.province_code,
          }
          }
        }
        if (this.ruleForm.send.save_info) {
          home.CreateAddress(this, 'send', 'S')
        }
        if (this.ruleForm.collect.save_info) {
          home.CreateAddress(this, 'collect')
        }
        if(this.isfrom){
          home.updateParcel(this, query).then((res) => {
            if (res.success) {
              this.$message.success("已保存到正常信息订单！");
              if(this.$store.state.mgcColorRow.includes(query.id)){
                this.$store.state.mgcColorRow.split(this.$store.state.mgcColorRow(query.id),1)
              }
              this.$router.push({path:'/sheet'})  
              this.$store.state.seetIndex = 2
            }
          });
        }else{
          home.updataBill(this, query).then((res) => {
            if (~~res.success) {
              this.$message.success('修改订单成功!')
              setTimeout(() => {
                this.first_click = true
                this.save_btn = false
                this.$store.commit('SET_ROUTE_FROM', '/waitPrinted')
                this.$router.push('./waitPrinted')
              }, 1000)
            } else {
              if (
                ~~res.data.code == 7010 ||
                ~~res.data.code == 7013 ||
                ~~res.data.code === 7011 ||
                ~~res.data.code === 7012 ||
                ~~res.data.code === 7018 ||
                ~~res.data.code === 7019
              ) {
                setTimeout(() => {
                  this.$parent.$refs.menuNav.goPath(2, '/waitPrinted')
                }, 1000)
              }
              this.first_click = true
              this.save_btn = false
            }
          })          
        }
      } else {
        this.$message({
          type: 'warning ',
          message: '单击次数过快，请稍后再试',
        })
        return
      }
    },
    /** 选择地址 */
    selectAddress(type) {
      this.address_type = type
      if (type == 'send') {
        this.dialog_title = '选择寄件人'
        setTimeout(() => {
          this.$refs.sendList.$refs.singleTable.clearSelection()
        }, 100)
      } else {
        this.dialog_title = '选择收件人'
        setTimeout(() => {
          this.$refs.collectList.$refs.multipleTable.clearSelection()
        }, 100)
      }
      this.dialog = true
    },
    servicesType(){

    },
    /** 编辑地址 */
    editAddress(index) {
      let editObj = this.Added_Collect[index]
      this.editcollectIndex = index
      this.ruleForm.collect = Object.assign(this.ruleForm.collect, editObj)
    },
    /**手动继续添加收件人 */
    addCollect() {
      this.changeTrigger('change')
      this.validateFields(this.fieldCollect, 'collect')
    },

    /** 删除收件人地址 */
    removeAddress(index) {
      this.Added_Collect.splice(index, 1)
    },

    /**输入其他物品类型 */
    inputOther() {
      this.$prompt('请输入品类', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^.{0,10}$/,
        inputErrorMessage: '物品类型不能超过十个字符',
      })
        .then(({ value }) => {
          this.typeContent = value
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入',
          })
          this.typeContent = ''
        })
    },
    /**校验收寄件人字段规则 */
    validateFields(fieldArr, type, from) {
      let success = []
      let _this = this
      this.$refs.ruleForm.validateField(fieldArr, (result) => {
        if (result != '') {
          // console.log("来自" + type + "有不满足的校验规则的");
          this.result = false
        } else {
          // console.log("来自" + type + "有满足校验规则");
          success.push(1)
          if (success.length == 4) {
            this.result = true
            if (type == 'collect' && from != 'save') {
              this.ruleForm.collect.type = 'add'
              let collectObj = {}
              const item = _this.ruleForm.collect
              collectObj.id = item.id
              collectObj.receiver_name = item.name
              collectObj.receiver_phone = item.phone
              collectObj.receiver_province_code = item.province_code
              collectObj.receiver_city_code = item.city_code
              collectObj.receiver_district_code = item.area_code
              collectObj.receiver_address = item.address
              home.CreateAddress(this, 'collect', 'R', collectObj)
              if (_this.editcollectIndex == -1) {
                this.Added_Collect.push(
                  JSON.parse(JSON.stringify(this.ruleForm.collect))
                )
              } else {
                this.Added_Collect[_this.editcollectIndex] = JSON.parse(
                  JSON.stringify(this.ruleForm.collect)
                )
                _this.editcollectIndex == -1
              }
              this.restFiled()
              this.changeTrigger('blur')
            }
            if (type == 'send' && from == 'save') {
              this.save_btn = true
              this.createParcel()
            }
          }
        }
      })
      setTimeout(() => {
        if (success.length != 4) {
          this.$message.error('打印信息填写有误，请查看重新填写')
        }
        // this.$hideLoading();
      }, 100)
    },

    /**改变校验规则触发状态 */
    changeTrigger(status) {
      this.rules['collect.name'][0].trigger = status
      this.rules['collect.phone'][0].trigger = status
      this.rules['collect.address'][0].trigger = status
      this.rules['collect.province'][0].trigger = status
      this.rules['collect.city'][0].trigger = status
      this.rules['collect.area'][0].trigger = status
    },

    /**checkFiled */
    checkFiled() {
      if (
        this.ruleForm.collect.name ||
        this.ruleForm.collect.phone ||
        this.ruleForm.collect.address ||
        this.ruleForm.collect.province ||
        this.ruleForm.collect.city ||
        this.ruleForm.collect.area ||
        this.ruleForm.collect.pca.length
      ) {
        return true
      } else {
        this.$refs.ruleForm.clearValidate(this.fieldCollect)
        return false
      }
    },

    /**重置字段 */
    restFiled() {
      this.ruleForm.collect.name = ''
      this.ruleForm.collect.phone = ''
      this.ruleForm.collect.province = ''
      this.ruleForm.collect.area = ''
      this.ruleForm.collect.city = ''
      this.ruleForm.collect.address = ''
      this.ruleForm.collect.pca = ''
      this.ruleForm.collect.area_code = ''
      this.ruleForm.collect.province_code = ''
      this.ruleForm.collect.city_code = ''
    },

    /**Error-Message */
    confirms() {
      let self = this
      self
        .$confirm(
          '收件信息输入框中有未确认信息，请点击【确认添加收件信息】，或清空所有输入框信息后再保存',
          '提示',
          {
            confirmButtonText: '确认添加收件信息',
            cancelButtonText: '一键清空输入框',
            type: 'warning',
          }
        )
        .then(() => {
          // 继续完成添加
          this.addCollect()
          self.save_btn = false
        })
        .catch(() => {
          // 一键清空输入框c
          self.save_btn = false
          self.restFiled()
          self.changeTrigger('blur')
          self.$refs.ruleForm.clearValidate()
        })
    },
    /**取消 */
    gotoback() {
      this.$confirm('数据尚未保存，是否退出', '提示', {
        confirmButtonText: '确定退出',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$store.commit('SET_ROUTE_FROM', '/waitPrinted')
          this.$router.push('./waitPrinted')
        })
        .catch(() => {})
    },

    /** 解析绑定地址 */
    changeAddress(type) {
      if (!type) return
      let address = this.$refs[type].getCheckedNodes()[0].pathLabels // 地址显示
      let code = this.$refs[type].getCheckedNodes()[0].path // 地区编码
      this.ruleForm[type].province = address[0]
      this.ruleForm[type].province_code = code[0]
      this.ruleForm[type].city = address[1]
      this.ruleForm[type].city_code = code[1]
      this.ruleForm[type].area = address[2]
      this.ruleForm[type].area_code = code[2]
    },
    handlePickGoods(goodObj, keep = false) {
      this.typeContent = goodObj.goods
      this.goods_weight = goodObj.weight
      this.showGoodsPicker && (this.showGoodsPicker = keep)
    },
  },
  beforeDestroy() {
  },
}
</script>

<style lang="stylus" scoped>
.home {
  padding-bottom: 90px;

  .forsign{
    display: flex;
    justify-content: flex-start;
    border-bottom: 1px solid #e8e8e8;
    height: 50px;
    padding: 0 40px;
    line-height: 50px;
    >div{
      margin-right 30px
      cursor: pointer;
      span{
        color #fabe00;
      }
    }
  }
  .model {
    background: #fff;
    border-radius: 4px;

    ._header {
      height: 50px;
      padding: 0 40px;
      border-bottom: 1px solid #E8E8E8;

      .left {
        float: left;
        line-height: 50px;
        font-size: 16px;
        font-weight: bold;
        color: rgba(33, 33, 33, 1);
        display: flex;
        align-items: center;

        img {
          width: 20px;
          height: 28px;
          vertical-align: middle;
          margin-right: 10px;
        }
      }

      .right {
        line-height: 50px;
        font-weight: 400;
        color: rgba(28, 139, 246, 1);
        display: flex;
        align-items: center;
        justify-content: flex-end;

        a {
          font-size: 14px;
          color: #1C8BF6;
        }

        img {
          width: 10px;
          height: 10px;
          vertical-align: middle;
          margin-right: 10px;
        }
      }
    }

    .from {
      padding: 20px 40px 10px 40px;
      max-width:1000px;
      margin:0 auto;
      position: relative;
      .header_title{
        position: absolute;
        left: 0px;
        top: -36px;
        font-size:14px;
        img{
          width: 20px;
          height: 28px;
          vertical-align: middle;
          margin-right: 10px;
        }
      }
      .addRecever{
        position: absolute;
        right: 60px;
        top: -44px;
        line-height: 50px;
        font-weight: 400;
        color: rgba(28, 139, 246, 1);
        display: flex;
        align-items: center;
        justify-content: flex-end;
        a {
          font-size: 14px;
          color: #1C8BF6;
        }
        img {
          width: 10px;
          height: 10px;
          vertical-align: middle;
          margin-right: 10px;
        }
      }

      .flexEnd{
        display flex;
        justify-content: flex-end
      }

      >.el-row {
        margin-bottom: 20px;
      }
      .collectBox{
        background: #f5f5f5;
        padding: 20px 20px 20px 0;
        border-radius: 9px;
        >.el-row {
          margin-bottom: 20px;
        }
        .flexBetween{
          display: flex;
          justify-content: space-between;
        }
      }
      .el-row {
        display: flex;
        align-items: center;
        font-size: 13px;

        .title {
          text-align: right;
          margin-right: 10px;
          color: #212121;
        }

        .input {
          /deep/ .el-form-item {
            margin-bottom: 0;

            .el-input {
              width: 97%;
              float: left;
            }

            /deep/ .el-form-item__content {
              margin: 0 !important;
            }
          }

          .el-cascader,.el-autocomplete {
            width: 97%;
            float: left;

            // margin-right:10px;
            /deep/.el-input {
              width: 100% !important;
            }
          }

          .el-select {
            width: 97%;
            float: left;

            /deep/.el-input {
              width: 100% !important;
            }
          }

          .span {
            color: #FF0000;
            font-size: 14px;
            float: right;
          }
        }
      }

      .checkbox {
        margin-left: 110px;
        font-size:13px
      }

      .parse {
        background: #1C8BF6;
        color: #fff;
        border-radius: 0 4px 4px 0;
      }
    }
  }

  .addressee {
    margin-top: 0px;

    .collect-list {
      height: 40px;
      display: flex;
      align-items: center;
      padding: 0 20px;
      background: rgba(28, 139, 246, 0.1);
      border-radius: 4px;
      color: #212121;
      justify-content: space-between;

      .left {
        flex: 1;
        display: flex;
        align-items: center;

        .rod {
          display: inline-block;
          width: 15px;
          height: 15px;
          border: 1px solid #333;
          border-radius: 100%;
          font-size: 12px;
          line-height: 17px;
          text-align: center;
          margin-right: 10px;
        }
      }

      .right {
        flex-basis: 60px;
        display: flex;
        align-items: center;
        justify-content: flex-end;

        img {
          width: 20px;
          height: 20px;
          cursor: pointer;
          margin-left: 15px;
        }
      }
    }
  }

  .other {
    .el-select {
      width: 100%;
    }

    .from {
      padding-top: 0;
    }

    .from > .el-row {
      margin-bottom: 0px;
    }

    .from .el-row {
      align-items: flex-start;

      .title {
        margin-top: 10px;
      }
    }

    .el-textarea {
      height: 100px;

      /deep/ .el-textarea__inner {
        height: 100%;
      }
    }
  }

  footer {
    background: #fff;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 40px;
    line-height: 40px;
    text-align: center;
    box-shadow: 1px 0 7px rgba(0, 0, 0, 0.1);
    z-index:99
    .footBtn{
        width 120px
        padding 8px 10px
    }
  }

  /deep/.el-textarea textarea {
    resize: none;
  }

  .home .other .el-textarea .el-textarea__inner {
    resize: none;
  }

  /deep/.el-textarea .el-input__count {
    line-height: 20px;
  }

  /deep/.el-form-item__content {
    margin-left: 0 !important;
  }
}
.forExample{
  display: flex;
  justify-content: flex-start;
  padding: 10px 0;
  font-size: 12px;
  color: #909399;
  .left{
    width 40px
    text-align left
  }
  .right{
    flex 1
  }
}
.cp_title{
  padding 10px 0;
  color #E6A23C;
  span{
    color #F56C6C
  }
}
.errorTip{
  color:#F56C6C
}
.ListItem span{
  padding-right:5px;
}
.flexEnd{
  padding-top 10px;
  display flex;
  justify-content: flex-end
}
.gotoback{
  display: flex;
  justify-content: flex-end;
  padding:10px 40px
}
.zzfu-n{
  margin:0 auto;
  max-width: 1080px;
}
</style>
